function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
export var BaseConfig = /*#__PURE__*/ function() {
    "use strict";
    function BaseConfig() {
        _class_call_check(this, BaseConfig);
        _define_property(this, "basePath", void 0);
    }
    _create_class(BaseConfig, [
        {
            key: "setBasePath",
            value: function setBasePath(basePath) {
                this.basePath = basePath;
            }
        },
        {
            key: "isMFA",
            get: /**
   * If external basePath is provided, it means that application is running as a
   * remote micro-frontend.
   */ function get() {
                return Boolean(this.basePath);
            }
        }
    ]);
    return BaseConfig;
}();

//# sourceMappingURL=base-config.js.map